<template>
  <div class="homeMenu">
    <div id="bg"></div>
    <div id="show">
      <div class="navs">
        <div class="banner">
          <a href="/" target="_blank">
            <span class="el-row">
              <img src="../../assets/images/ora_logo.png" />
            </span>
          </a>
          <span class="el-row">
            <img
              src="../../assets/images/Group 11897.png"
              id="btnclose"
              @click="hidediv()"
            />
          </span>
        </div>
        <!-- 选项 -->
        <div class="grid-content">
          <el-menu
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="/home" class="soya-item">
              <p :class="{ 'soya-menu': $t('lang') == 'de' }">
                {{ $t("myhome") }}
              </p> </el-menu-item
            ><br />
            <el-menu-item index="/brand" class="soya-item">
              <p :class="{ 'soya-menu': $t('lang') == 'de' }">
                {{ $t("brand") }}
              </p> </el-menu-item
            ><br />
            <el-menu-item index="/InfoCollection" class="soya-item">
              <p :class="{ 'soya-menu': $t('lang') == 'de' }">
                {{ $t("InfoCollection") }}
              </p> </el-menu-item
            ><br />
            <!-- <el-menu-item index="/contractUs">
              <p :class="{ 'soya-menu': $t('lang') == 'de' }">
                {{ $t("contact") }}
              </p>
            </el-menu-item> -->
            <br />
          </el-menu>
        </div>
        <!-- 语言切换 -->
        <div class="language">
          <el-menu :default-active="activeIndex2" mode="horizontal">
            <el-menu-item index="4" class="enchange" @click="changeLang('en')">
              {{ $t("en") }}
            </el-menu-item>
            <el-menu-item index="5" class="dechange" @click="changeLang('de')">
              {{ $t("de") }}</el-menu-item
            >
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from "../../i18n";

export default {
  name: "homeMenu",
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "4",
      navsshow: false,
      lang: "",
      langList: [
        {
          name: "ENGLISH",
          value: "EN",
        },
        {
          name: "DEUTSCH",
          value: "DE",
        },
      ],
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "en";
    console.log(this.lang);
    this.activeIndex2 = this.lang === "en" ? "4" : "5";
  },
  methods: {
    handleSelect(index) {
      console.log(index);
      window.open("#" + index, "_blank");
    },
    handleShow() {
      // this.navsshow = true;
      // console.log(this.navsshow);
    },
    showdiv: function () {
      document.getElementById("bg").style.display = "block";
      document.getElementById("show").style.display = "block";
    },
    hidediv: function () {
      document.getElementById("bg").style.display = "none";
      document.getElementById("show").style.display = "none";
    },
    changeLang(lang) {
      i18n.locale = lang;
      localStorage.setItem("locale", lang);
      this.lang = lang;
      console.log(this.lang);
    },
  },
};
</script>
<style scoped lang="scss">
@media screen and (min-width: 768px) {
  .homeMenu {
    display: none;
  }
}

/* 显示小屏幕样式 */
@media screen and (max-width: 767px) {
  .navs {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: white;
  }
  .soya-menu {
    font-size: 44px;
  }
  .homeMenu {
    height: 100%;
    display: block;
  }

  #bg {
    display: none;
    /* position: absolute; */
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    background-color: black;
    z-index: 1001;
    -moz-opacity: 0.7;
    opacity: 0.7;
    filter: alpha(opacity=70);
  }

  #show {
    display: none;
    position: absolute;
    top: 0;
    left: 0%;
    width: 100%;
    // height: 823px;
    height: 100%;
    z-index: 999;
    background: #fff;
    z-index: 1002;
    overflow: auto;
  }

  .banner {
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 4%;
    border-bottom: #000 1px solid;
  }

  .banner img {
    height: 40px;
  }

  .grid-content {
    display: flex;
    margin-top: 0;
    padding: 5% 3% 0 0 !important;
    justify-content: flex-end;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 1px solid #333;
    color: #333;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    color: #fff;
  }

  .el-menu--horizontal > .el-menu-item {
    float: right;
    height: 100px;
    line-height: 100px;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: #303133;
    font-family: OpenSansBold;
  }

  .el-menu-item {
    font-size: 50px;
    font-weight: bold;
    color: #303133;
    padding: 0;
    cursor: pointer;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    box-sizing: border-box;
  }

  .language {
    display: inline-block;
    margin-left: 100px;
  }

  .language .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: none;
    background: #fe6927 !important;
    color: #fff;
    height: 80px;
  }

  .language .el-menu--horizontal > .el-menu-item {
    float: left;
    height: 92px;
    line-height: 92px;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: #303133;
    padding: 0 10px;
  }

  .enchange {
    margin-right: 40px !important;
  }

  .soya-item {
    margin-bottom: 34px !important;
  }
}
</style>